// import { Component } from '@angular/core';

// @Component({
//   selector: 'app-upsert',
//   standalone: true,
//   imports: [],
//   templateUrl: './upsert.component.html',
//   styleUrl: './upsert.component.scss'
// })
// export class AssetReservationUpsertComponent {

// }

import { FormatService } from '~/services/administration.ts/format';
import { Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SecurityService } from '~/services/security.service';
import { SharedService } from '~/services/sharedService';
import { ThemeManagerService } from '~/services/theme-manager';
import { PageState } from '~/shared/enums/stock-files.enum';
import { GridFieldTextSummary } from '~/models/modules/GridFieldText';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { Observable, finalize, Subscription, BehaviorSubject, firstValueFrom } from 'rxjs';
import { VendorsService } from '~/services/modules/stocks/vendors';
import { ComponentBase } from '~/infrastructure/component-base';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import { UserSummary } from '~/models/administration/user';
import { GridFieldAuthorization } from '~/models/administration/securityLevel';
import { BarcodeGeneratorsService } from '~/services/modules/stocks/barcode-generators';
import { LayoutManagerService } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { FundingSourceService } from '~/services/modules/assets/fundingSource';
import { EnvironmentLoaderService } from '~/services/BackEndURL/environment-loader.service';
import { fileSources } from '~/shared/enums/fileSources';
import { GDataService } from '~/services/GDataService';
import { AssetPoPreference } from '~/models/administration/AssetPoPreference';
import { IAssetReservationDto } from '~/models/modules/Asset/Transactions/Reservation/IAssetReservationDto';
import { IAssetDto, IAssetListing } from '~/models/modules/Asset/asset';
import { Router } from '@angular/router';
import { AssetPrintReceiptsService } from '~/services/administration.ts/asset-print-receipts.service';
import { AssetPrintReceipt } from '~/models/administration/assetPrintReceipt';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { AssetService } from '~/services/modules/assets/asset.service';
import { AssetCheckOutTransactionsService } from '~/services/modules/assets/transactions/checkOutTransaction';
import { UsersService } from '~/services/administration.ts/users';
import { LocationsService } from '~/services/modules/stocks/locations';
import { QuantityFormatsService } from '~/services/administration.ts/quantity-formats';
import { TransactionDateEditingSettingsService } from '~/services/administration.ts/transaction-date-editing-settings.service';
import { FilesService } from '~/services/modules/stocks/files';
import { SystemTransactionsFieldsService } from '~/services/modules/common/system-transactions-fields.service';
import { ConditionsService } from '~/services/modules/assets/condition';
import { StatusesService } from '~/services/modules/assets/status';
import { NotesService } from '~/services/modules/stocks/notes';
import { CheckOutInSettingsService } from '~/services/administration.ts/check-out-in-settings.service';
import { ReportsService } from '~/services/modules/reports/reports';
import { systemTransactionsList } from '~/models/modules/Common/systemTransactionList';
import { ISystemTransactionsFields } from '~/models/modules/Common/systemTransactionsFieldsDto';
import { GridFieldSummary } from '~/models/modules/gridField';
import { LocationListing, LocationSummary } from '~/models/modules/location';
import { StatusDto } from '~/models/modules/Asset/status';
import { ConditionDto } from '~/models/modules/conditions';
import { PersonSummary } from '~/models/administration/person';
import { ICheckOutInSettings } from '~/models/administration/checkOutInSettings';
import { DataWithPagingMetadata } from '~/infrastructure/paging';
import { NoteSummary } from '~/models/modules/note';
import { FormatTypes } from '~/shared/enums/FormatTypes';
import { AssetListMode } from '~/models/modules/Asset/Transactions/CheckOut/assetListMode';
import { NumericTextBoxComponent } from '@progress/kendo-angular-inputs';
import { GridLayoutComponent } from '~/shared/components/grid/layout/layout.component';
import { CustomFieldSummary } from '~/models/modules/customField';
import { FileInfo, SelectEvent, UploadComponent } from '@progress/kendo-angular-upload';
import { FileSelectedStream } from '~/models/modules/file';
import { allowedFileTypes } from '~/shared/enums/allowedFileTypes';
import { ReportViewerPopupComponent } from '~/shared/components/viewer/popup.component';
import { IAssetReservationDetailsDto } from '~/models/modules/Asset/Transactions/Reservation/assetReservationDetailsDto';
import { EntityStatusOptions } from '~/models/entityStatus';
import { AssetReservationService } from '~/services/modules/assets/transactions/asset-reservation.service';
import { TransactionDateEditingService } from '~/services/modules/stocks/administration/transaction-date-editing';
import { TabPosition, TabStripComponent } from '@progress/kendo-angular-layout';
import { FormTabSummary } from '~/models/modules/formTab';
import { CustomFieldsService } from '~/services/modules/stocks/custom-fields';
import { SitesEnum } from '~/shared/enums/sites.enum';
import { MultiSiteAwareComponent } from '~/infrastructure/multi-site-aware.component';
@Component({
    selector: 'app-asset-reservation-upsert',
    templateUrl: './upsert.component.html',
    styleUrl: './upsert.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AssetReservationUpsertComponent
  extends MultiSiteAwareComponent
  implements OnInit {
  @ViewChild('mainWindow') kendoMainWindow: ElementRef;
  _active: boolean = true;
  _showTransactionFieldEditor: boolean = false;
  _transactionsFieldEditorObjectCode: string = ''
  _pageState: PageState;

  _permissionScope = 'asset-reservation';
  _page = 'asset-reservation';
  _entity = 'Asset';
  _language = 'en';
  _theme: string;
  _form: FormGroup;
  _model: IAssetReservationDto;
  copyModelId: number;
  _customForm: any;
  _gridFieldText: GridFieldTextSummary[];
  _storagePath: string;

  selectedobjectname: string = null;



  _dialogComponentName: string;
  _isDialiog: boolean = false;
  _dialogModel: any;


  _currentUser: UserSummary;
  _hasFieldControlLicense: boolean = false;
  _selectedCallback = (args: { dataItem: any }) => args.dataItem;
  _gridFieldAuth: GridFieldAuthorization[];
  _minDate: Date = new Date(1901, 1, 1);
  _isNew: boolean = true;

  isScanInventoryExpanded: boolean = true;
  _invalidForm: boolean;

  _innerWidth: any;
  _hiddenWindow: any;
  _maximized: any;
  _isOs: boolean;

  reloadlist: any;


  // _poNumber = new FormControl();

  pageState = PageState; // For Using Enum in Html
  _isAnyItemReceived: boolean = false;
  _selectedAccounts: any[] = [];

  // #region Popup Statuses
  _editFormActive: boolean;
  _orderingTabsForm: boolean = false;
  _deactivatedFieldsForm: boolean = false;
  _isEditForms: boolean = false;
  _selectedTabId: number;
  _selectedLabelId: number;
  _deactivatedFieldsGridData: any[] = [];
  // #endregion
  // #region Tab Containers
  _kendoTabStripPosition: TabPosition = 'left';
  _dataTabs: Array<FormTabSummary> = [];
  _dataTabsSelected: Array<FormTabSummary> = [];
  _userNewDataTabs: Array<FormTabSummary> = [];
  _customTabs: any;
  _tabDisabledIndexes: number[] = [];
  // #endregion
  // #region Custom Fields / Edit Form
  _isCustomfieldsFormValue: boolean = false;
  _isAddTabFormValue: boolean = false;
  _isRenameLabel: boolean = false;
  _selectedLabelObjectCode: string;
  _isRenameFormValue: boolean = false;
  _isRenameCustomFormValue: boolean = false;
  _isMandatory: boolean = false;
  _custominvalidForm: boolean = false;
  reactivate: boolean = false;
  reactivateItem: any;
  requiredSystemTabs: any = [];
  _requiredFieldNames: any = [];
  _requiredFields: any = [];
  _additionalErrors: any = [];

  _customFields: CustomFieldSummary[][] = [];
  _customFieldsDictionary: { [key: string]: string } = {};
  _customFieldsValue: any[] = [];
  _customValidation: any = [];
  _systemFields: GridFieldSummary[] = [];
  _editedSystemFields: any = [];
  // #endregion

  //#region Asset Po Preference Settings
  _assetPoPreferencesSettings: AssetPoPreference;
  //#endregion

  _note: string;


  // #region Current Page Specific
  _sortingSelected = new FormControl('old');
  costPriceFormatType: FormatTypes = FormatTypes.CostandPriceFormat;
  isGeneralInformationExpanded: boolean = true;
  isScanAssetExpanded: boolean = true;
  _datePickerFormat: string;
  quantityFormat: string;
  _costFormat: string;
  digitNumber: number;
  _dateEnabled: boolean;
  transactionId: number;
  _assetListType: AssetListMode = AssetListMode.allAssets;


  //#region Asset Print Receipt Fields
  _printReceiptSettings: AssetPrintReceipt;
  showReports: boolean = false;
  receiveReports: any = [];
  @ViewChild('kendo_combo_Receipt_Report') selectReceiptReport: ComboBoxComponent;
  @ViewChild('kendo_tabstrip_wrapper') screenTabs: ElementRef;
  @ViewChild('kendo_tabstrip') public screenTabStrip: TabStripComponent;

  //#endregion

  //#region Selected Items
  public get selectedItems(): FormArray {
    return <FormArray>this._form.get('selectedItems');
  }
  _transactionFields: ISystemTransactionsFields[] = [];
  _assetsTransactionGridFields: GridFieldSummary[] = [];
  _assetsEditableTransactionGridFields: GridFieldSummary[] = [];
  _blackListedConditions: number[] = [];
  /* Multiple Selection and Batch Removal */
  _gridSelectedAssets: number[] = [];
  //#endregion

  //Check Out Settings
  checkOutInSettings: ICheckOutInSettings = <ICheckOutInSettings>({});
  _locationVisible: boolean = false;
  _locationEnabled: boolean = false;
  _personVisible: boolean = false;
  _personEnabled: boolean = false;

  ////// Person ////////
  _personsCode = new FormControl();
  personsData: PersonSummary[] = [];
  _personsAuth: GridFieldAuthorization;
  _personsDD = new FormControl();
  _personsListEnabled: boolean = false;
  _personsGridFields: GridFieldSummary[] = [];
  _personsPageName: string = 'persons'
  _selectedPerson: number;


  ////// Condition ////////
  _conditionCode = new FormControl();
  conditionsData: ConditionDto[] = [];
  _conditionsAuth: GridFieldAuthorization;
  _conditionsDD = new FormControl();
  _conditionsListEnabled: boolean = false;
  _conditionsGridFields: GridFieldSummary[] = [];
  _conditionsPageName: string = 'conditions'
  _selectedCondition: number;

  ////// Statuses ////////
  _statusesCode = new FormControl();
  statusesData: StatusDto[] = [];
  _statusesAuth: GridFieldAuthorization;
  _statusesDD = new FormControl();
  _statusesListEnabled: boolean = false;
  _statusesGridFields: GridFieldSummary[] = [];
  _statusesPageName: string = 'statuses'
  _selectedStatus: number;

  /////// Location Common //////
  locationsData: LocationListing[] = [];
  _locationsAuth: GridFieldAuthorization;
  _locationsGridFields: GridFieldSummary[] = [];
  _locationsPageName: string = 'locations'
  _locationsListEnabled: boolean = false;
  _selectedLocation: number;
  _locationsCode = new FormControl();
  _locationsDD = new FormControl();

  /////// Assets Data Listing //////
  assetsData: IAssetDto[] = [];
  assetsDataFiltered: IAssetDto[] = [];
  _assetsAuth: GridFieldAuthorization;
  _assetsGridFields: GridFieldSummary[] = [];
  _assetsPageName: string = 'assets'
  _assetsListEnabled: boolean = false;
  _selectedAssets: number[] = [];
  _assetsCode = new FormControl();
  _assetsDD = new FormControl();

  _assetComboBoxPagingParams = {
    currentItem: '0',
    totalbyPage: 20,
    search: '',
    page: 1
  };
  _assetComboScroll: boolean = false;
  _assetDDSearch: string = null;
  _assetDDSize: number = 20;

  public virtual: any = {
    itemHeight: 28,
    pageSize: 20
  };
  isOpened: boolean = false;
  clearTimeout: any;
  _allAssetCount: number = 0;
  _dueDateMin: Date = new Date();
  _minDateToday: Date = new Date(new Date().setHours(0, 0, 0, 0));
  _requireDueDate: boolean = true;
  _allowCheckedOutAssets: boolean = false;

  behavior: BehaviorSubject<GridFieldSummary[]>;


  @ViewChild('kendo_uploader') upload: UploadComponent;
  @ViewChild('kendo_uploader_wrapper') uploadWrapper: ElementRef;
  @ViewChild('Kendo_Combobox_ToLocation') kendoComboLocation: ComboBoxComponent;
  @ViewChild('Kendo_Combobox_Persons') kendoComboPersons: ComboBoxComponent;
  @ViewChild('asset_DueDays') asset_DueDays: NumericTextBoxComponent;
  @ViewChild('Kendo_Combobox_Assets') kendoComboAssets: ComboBoxComponent;
  @ViewChild('clearButton') clearButton: ElementRef;
  @ViewChild('SelectedItemsGrid') SelectedItemsGrid: GridLayoutComponent<any>;



  _canEditTransactionDate: boolean = false;


  // #region Attach Document
  _uploadedStream: FileSelectedStream[] = [];
  _selectedExistingFiles: FileSelectedStream[] = [];
  _fileSource: fileSources;
  _uploaderSelectMessage: string = 'Upload file..';
  _showDocumentsGrid: boolean = false;
  _selectedDocumentsKeys: number[] = [];
  _selectedDocuments: any[] = [];
  _selectedObjectDocuments: any[] = [];
  _allowedFileTypes: allowedFileTypes[] = [allowedFileTypes.excel, allowedFileTypes.pdf, allowedFileTypes.word];
  _file: File;
  _fileStream: any;
  _selectFile: boolean = false;
  _selectedInventoryKeys: number[] = [];
  // #endregion

  _selectedItems: IAssetReservationDetailsDto[] = [];

  constructor(
    private _barcodeGeneratorsService: BarcodeGeneratorsService,

    private _fb: FormBuilder,
    private _assetService: AssetService,
    private _assetCheckOutTransactionsService: AssetCheckOutTransactionsService,
    private _gridLayoutManagerService: GridLayoutManagerService,
    private _sharedService: SharedService,
    private _securityService: SecurityService,
    private _themeManager: ThemeManagerService,
    private router: Router,
    private _dataService: GDataService,
    private _usersService: UsersService,
    private _locationsService: LocationsService,
    private _layoutManager: LayoutManagerService,
    private _gridFields: GridFieldsService,
    private _formatService: FormatService,
    private quantityFormatsService: QuantityFormatsService,
    private _dateEditingSettings: TransactionDateEditingSettingsService,
    private _filesService: FilesService,
    private _systemTransactionFieldsService: SystemTransactionsFieldsService,
    private _conditionsService: ConditionsService,
    private _statusService: StatusesService,
    private _notesService: NotesService,
    private _renderer2: Renderer2,
    private _checkOutInSettingsService: CheckOutInSettingsService,
    private _assetPrintReceiptsService: AssetPrintReceiptsService,
    private _reportService: ReportsService,
    private _layoutComponent: LayoutComponent,
    private _assetReservationService: AssetReservationService,
    private _customFieldsService: CustomFieldsService,

  ) {
    super();
    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });
  }
  // ngOnInit(): void {
  //   this._storagePath = EnvironmentLoaderService.envConfig.enterpriseApiLocal + '/';

  //   this._initForm();
  //   //#region Get Current User
  //   this._currentUser = this._securityService.currentUser;
  //   if (!this._currentUser.isEnterprise) {
  //     const loggedInAccountSites =
  //       localStorage.getItem('loggedInAccountSites') ?? '';
  //     if (loggedInAccountSites != '') {
  //       this._form.patchValue({
  //         account: {
  //           id: JSON.parse(loggedInAccountSites)[0].accountId,
  //           name: '',
  //         },
  //         //site: { id: JSON.parse(loggedInAccountSites)[0].siteId, name: '' },
  //       });

  //     }
  //   }
  //   //#endregion
  //   this.getAuth();
  //   this.loadLabels();

  ngOnInit(): void {
    this._sortingSelected.valueChanges.subscribe((x) => {
      let TempAssetDataArray = [...this._selectedItems];
      TempAssetDataArray.reverse();
      this._selectedItems = [...TempAssetDataArray];
    });

    this._pageState = PageState.ADD;
    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });

    if (window.navigator.userAgent.indexOf('Mac') != -1) {
      this._isOs = true;
    };

    this._storagePath = EnvironmentLoaderService.envConfig.enterpriseApiLocal + '/';
    this._layoutManager.applyOverly();
    this._currentUser = this._securityService.currentUser;
    this._securityService.getLicense().subscribe((data: any) => {
      this._hasFieldControlLicense = !!data?.general?.fieldControl;
    });
    /* Check if All Site */
    if (!this._currentUser.isEnterprise) {
      var loginInSites = JSON.parse(localStorage.getItem('loggedInAccountSites'));
      let siteId = loginInSites[0].siteId;

      if (siteId == null) {
        this.router.navigate(['/']);
      } else if (siteId == SitesEnum.AllSites) {
        // All Sites selected, proceed without site filter
      }
    }
    /** Format */
    this._datePickerFormat = this._formatService.dateFormat;
    this._costFormat = this._formatService.costFormatValue;

    this.getPrintReceiptSettings();
    this.getTransactionFields();
    this.getDateEnabledOption();
    this.getdata();
    this._initForm();
    this._getdata();
    this._setGridFieldBehaviour();
    this._getAccountIds();
    //#endregion
    this.getAuth();
    this.loadLabels();
    this.getFormTabs();
    this.getSystemFieldsAndCustomFields();
    this._getInactiveFields();
    //#region Add From Popup

    this._dataService.dataTransferObservable.subscribe(str => {
      if (str.component == 'locations') {
        this._onCloseAddLocation(str);
      }
      else if (str.component == 'persons') {
        this._onCloseAddPersons(str);
      }
      else if (str.component == 'assets') {
        this._onCloseAddAsset(str);
      }
    });

    this.getPersonsDD();
    this.getPersonsAuth();
    this.getLocationsDD();
    this.getLocationsAuth();
    this.getCheckOutInSettings();
    this.getAssetsDD();
    this.getAssetsAuth();

    this._form.controls.assetNumber.valueChanges.subscribe((val: IAssetListing) => { this._handleAssetValueChange(val); });

    this.setLocationFocus();


  }


  ngAfterViewInit() {

  }

  //#region Get Settings Data

  //#endregion

  _initForm() {

    this._form = this._fb.group({
      id: [this._model?.id],
      reservationMadeDate: [this._model?.reservationMadeDate ? new Date(this._model.reservationMadeDate) : new Date(), Validators.required],
      reservationNumber: [this._model?.reservationNumber, Validators.required],
      toBeCheckedOutDate: [this._model?.toBeCheckedOutDate ? new Date(this._model.toBeCheckedOutDate) : new Date(), Validators.required],
      // toBeCheckedOutDate: this._fb.control(
      //   {
      //     value: this._model?.toBeCheckedOutDate
      //       ? new Date(this._model.toBeCheckedOutDate)
      //       : new Date(),
      //     disabled: this._model != null && Object.keys(this._model).length > 0
      //   },
      //   Validators.required
      // ),
      toBeCheckedInDate: [this._model?.toBeCheckedInDate ? new Date(this._model.toBeCheckedInDate) : new Date(), Validators.required],
      // toBeCheckedInDate: this._fb.control(
      //   {
      //     value: this._model?.toBeCheckedInDate
      //       ? new Date(this._model.toBeCheckedInDate)
      //       : new Date(),
      //     disabled: this._model != null && Object.keys(this._model).length > 0
      //   },
      //   Validators.required
      // ),
      checkOutToLocation: [this._model?.checkOutToLocation, Validators.required],
      checkOutToPerson: [this._model?.checkOutToPerson, Validators.required],
      notes: [this._model?.notes, this.getLabel('LBL_AssetCheckOutNotes')?.isRequired ? Validators.required : null],
      selectedItems: this._fb.array([]),

      site: [this._model?.site],
      assetNumber: [null],
      printReceipt: [false],
      stream: [null],
    });


    // this._pageState = !this._model || Object.keys(this._model).length == 0 ? PageState.ADD : PageState.EDIT;

    this._selectedItems = this._model?.assetReservationDetails
      ? this._model.assetReservationDetails.map((item, index) => ({
        id: item.id,
        index: index + 1,
        assetId: item.assetId,
        assetNumber: item.asset?.assetNumber ?? '',
        assetName: item.asset?.assetName ?? '',
        asset: item.asset ?? null,
        locationCode: item.asset?.location?.code ?? '',
        isCheckedOut: item.isCheckedOut ?? false,
      }))
      : [];

  }

  _onCancel() {
    this._closeForm();
  }

  _closeForm(model: any = null) {
    this.reloadlist = this._sharedService.model.reload;
    var closeComponent = {
      component: 'asset-reservation',
      isClosed: true,
      response: this.reloadlist === undefined ? null : model
    };

    this._active = false;
    this._gridLayoutManagerService.setGridDataSubjects('asset-reservation');
    this._layoutManager.setFromChanged('asset-reservation');
    this.ngOnDestroy();
    this._sharedService.closeDialog.emit(closeComponent);
    this._sharedService.closeDialog.emit(closeComponent);
    this._sharedService.model = {};
    //Quraim
    if (model) {
      closeComponent.response = model;
      this._dataService.push(closeComponent);
      this._sharedService.model = {};
    }
  }

  _onStateChanges(e: any) {
    var element: any = this.kendoMainWindow;

    if (e === 'minimized') {
      element.el.nativeElement.classList.remove('fullWidthFormForm');
    }
    else if (e === 'maximized') {
      element.el.nativeElement.classList.remove('fullWidthFormForm');
    }
    else if (e === 'default') {
      element.el.nativeElement.classList.add('fullWidthFormForm');
    }
  }



  openUpsert(componentName: string, model: any, pageState: PageState) {
    this._isDialiog = true;
    this._dialogComponentName = componentName;
    this._dialogModel = { model, pageState };
    this._initForm();
  }
  //#endregion

  //#region Expand And Collapse Actions
  ExpandCollapseScanInventoryWidget(isExpand: boolean) {
    this.isScanInventoryExpanded = !isExpand;
  }


  //#endregion
  _edit(): void {
    this._pageState = PageState.EDIT;
  }

  //#region Security Actions
  canAccess(scope: string, operation: string): boolean {
    return this._securityService.hasPermission(null, `${scope}-${operation}`);
  }

  getAuth() {
    // this._gridFields.getFileAuthorization(this._auth, this._currentUser.appRole.id)
    this._gridFields.getFieldsAuthorization(this._page, this._currentUser.appRole.id).subscribe((x: GridFieldAuthorization[]) => {
      this._gridFieldAuth = x;
    });
  }

  getAuthByLabel(objectCode: any) {
    if (this._gridFieldAuth) {
      if (this._gridFieldAuth.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode)) {
        var result = this._gridFieldAuth.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode);
      }
      else {
        result = null;
      }
      return result ? result : new GridFieldAuthorization();
    }
  }


  getPersonsAuth() {
    this._gridFields.getFileAuthorization('mnuUser', this._currentUser.appRole.id).subscribe((x: GridFieldAuthorization) => {
      this._personsAuth = x;
    });
  }
  getLocationsAuth() {
    this._gridFields.getFileAuthorization('mnuLocation', this._currentUser.appRole.id).subscribe((x: GridFieldAuthorization) => {
      this._locationsAuth = x;
    });
  }
  getAssetsAuth() {
    this._gridFields.getFileAuthorization('mnuAsset', this._currentUser.appRole.id).subscribe((x: GridFieldAuthorization) => {
      this._assetsAuth = x;
    });
  }
  //#endregion
  getLabel(objectCode: string): GridFieldTextSummary {
    if (this._gridFieldText) {
      if (this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode)) {
        var result = this._gridFieldText.find(({ gridFieldDefinition }) => gridFieldDefinition?.objectCode === objectCode);
      }
      else {
        result = null;
      }

      return result ? result : null;
    }
  }


  //#region Generate Barcode
  _generateBarcodeClick() {
    this.runGenerateBarcode();
  }

  private runGenerateBarcode() {
    let counter = 1;
    this.generateBarcode(counter).subscribe((data: any) => {
      this._form.patchValue({ reservationNumber: data.result.toString() });

    });
  }

  private generateBarcode(quantity: number) {
    return this._barcodeGeneratorsService.getBarcode('asset-reservation', quantity);
  }

  reservationNumberChanged() {
  }

  //#endregion

  getPrintReceiptSettings() {
    this._assetPrintReceiptsService.getPrintReceipt().subscribe((data) => {
      if (data) {
        this._printReceiptSettings = { ...data };
      }
    });

  }

  private async getTransactionFields() {
    this._systemTransactionFieldsService.getFieldsByTransaction(systemTransactionsList.assetcheckOut).subscribe((data: ISystemTransactionsFields[]) => {
      this._transactionFields = <ISystemTransactionsFields[]>([...data]);
      this.setSelectedGridFields();

      setTimeout(() => {
        //this.clearButton.nativeElement.click();
        this.getCheckOutInSettings();
      }, 500);
    });
  }

  setSelectedGridFields() {
    this._assetsTransactionGridFields = this._transactionFields.map(f => f.gridFieldDefinition);
    this._assetsTransactionGridFields.forEach((f: GridFieldSummary) => {
      f.selected = true;
    });
  }

  getCheckOutInSettings() {
    this._checkOutInSettingsService.getCheckOutInSettings().subscribe((data: ICheckOutInSettings) => {
      this.checkOutInSettings = { ...data };
      // Check Out Options
      if (this.checkOutInSettings.chechOutToLocation == true) {
        this._personVisible = false;
        this._personEnabled = false;
        this._locationVisible = true;
        this._locationEnabled = true;
        this._form.controls.checkOutToPerson.clearValidators();
        this._form.controls.checkOutToPerson.setErrors([null]);
        this._form.controls.checkOutToPerson.updateValueAndValidity();
      }
      else if (this.checkOutInSettings.chechOutToPerson == true) {
        this._personVisible = true;
        this._personEnabled = true;
        this._locationVisible = false;
        this._locationEnabled = false;
        this._form.controls.checkOutToLocation.clearValidators();
        this._form.controls.checkOutToLocation.setErrors([null]);
        this._form.controls.checkOutToLocation.updateValueAndValidity();

        if (this.checkOutInSettings.setPersonLoggedIn == true) {
          this._form.controls.checkOutToPerson.setValue(this._currentUser.person);
          this._form.patchValue({ checkOutToPerson: this._currentUser.person });
          this._personsDD.setValue(this._currentUser.person);
          this._form.controls.checkOutToPerson.disable();
          this._personEnabled = false;
        }
      }
      else if (this.checkOutInSettings.chechOutToBoth == true) {
        this._personVisible = true;
        this._personEnabled = true;
        this._locationVisible = true;
        this._locationEnabled = true;
        if (this.checkOutInSettings.setPersonLoggedInBoth == true) {
          this._form.controls.checkOutToPerson.setValue(this._currentUser.person);
          this._form.patchValue({
            checkOutToPerson: this._currentUser.person
          });
          this._form.controls.checkOutToPerson.disable();
          this._personEnabled = false;
        }
      }
      //Check Out Setting
      this._requireDueDate = !this.checkOutInSettings.allowNoDueDate;

      if (this.checkOutInSettings.allowCheckOutOfCheckedAssets == true) {
        this._allowCheckedOutAssets = true;
      }
      // //time frame (default due days)
      // let setAsDefaultValue = this._form.controls.setAsDefault.value ?? false;

      // if (setAsDefaultValue == false && (this._form.controls.checkOutDueDays.value == null || this._form.controls.checkOutDueDays.value == '' || this._form.controls.checkOutDueDays.value == undefined)) {
      //   if (this.checkOutInSettings.defaultDateTimeFrame != undefined && this.checkOutInSettings.defaultDateTimeFrame != null) {
      //     if (this.checkOutInSettings.defaultDateTimeFrame > 0) {
      //       this._form.controls.checkOutDueDays.setValue(this.checkOutInSettings.defaultDateTimeFrame);
      //     }
      //   }
      // }
    });
  }

  async _getdata() {
    this._model = this._sharedService.model && this._sharedService.model.model ? this._sharedService.model.model : null;
    this.quantityFormat = await this.quantityFormatsService.getQuantityFormatForNumericTextBox();
    this.digitNumber = await this.quantityFormatsService.getDigitNumber(this.quantityFormat);
  }

  _getAccountIds() {
    super._getAccountIds();
  }

  private loadLabels(): void {
    this._gridFields.getGridFieldTextLabelByPage(this._page, this._language).subscribe((data: GridFieldTextSummary[]) => {
      this._gridFieldText = data;
      //this._initForm();
    });
  }

  _setGridFieldBehaviour() {
    this.behavior = this._gridLayoutManagerService.subscribeToColumnsChanges2();
    this.behavior.subscribe(value => {
      if (value != undefined && value != null) {
        let pagename = value.map((a: any) => a.page).shift();
        let Gridresualt = value.filter((a: any) => a.selected === true && a.page === pagename);
        switch (pagename) {
          case 'persons': {
            this._personsGridFields = Gridresualt;
            break;
          }
          case 'locations': {
            this._locationsGridFields = Gridresualt;
            break;
          }
          case 'assets': {
            this._assetsGridFields = Gridresualt;
            break;
          }
        }
      }
    });
  }

  // #region Location / home Location Drop Down
  // Common
  async getLocationsDD() {
    var response = this._locationsService.getLocationListing();
    var data = await firstValueFrom(response);

    if (data) {
      this.locationsData = data;
    }
  }

  _openLocationsList(): void {
    if (this._locationsGridFields == undefined || this._locationsGridFields.length == 0) {
      this._getLocationsGridFields();
    }

    this._locationsListEnabled = true;
  }

  _getLocationsGridFields() {
    this._gridFields.getGridFieldsByPage(this._locationsPageName).subscribe((data: any) => {
      this._gridLayoutManagerService.setGridColumnSubjects(this._locationsPageName, data);
    });

    this._gridLayoutManagerService.subscribeToColumnsChanges(this._locationsPageName, (gridColumns) => {
      this._locationsGridFields = gridColumns;
    });
  }

  _closeLocationsList(): void {
    this._locationsListEnabled = false;
  }

  _returnSelectedLocationsHandler(e: LocationSummary): void {
    this._locationsService.getLocation(this._selectedLocation).subscribe((data: any) => {
      if (this.locationsData.find(f => f.id == data.id) == undefined) {
        this.locationsData.push(data);
      }

      this._locationsDD.setValue(data);
      this._form.patchValue({ checkOutToLocation: data });
    });

    this._closeLocationsList();
  }

  _onLocationsRowSelectionChanges(e: any[]) {
    this._selectedLocation = e[0];
  }

  _onLocationsObjectRowSelectionChanges(e: any[]) {

  }

  _getLocations = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._locationsService.getLocations(params, model);
  };

  _onOpenLocationForm(): void {
    this._openForm(this._locationsPageName);
  }

  async _onCloseAddLocation(data: any) {
    const tempData = this.locationsData;
    await this.getLocationsDD();

    if (tempData.length != this.locationsData.length) {
      let latestItem = this.locationsData.at(this.locationsData.length - 1);
      // let newItem = data.response;
      // this.locationsData.push(newItem);
      this._locationsDD.setValue(latestItem);
      this._form.patchValue({
        checkOutToLocation: latestItem
      });

      this._form.controls.checkOutToLocation.updateValueAndValidity();
      this._locationsDD.updateValueAndValidity();
    }
  }

  _handleLocationChange(e: any) {
    if (e) {
      setTimeout(() => {
        if (!this.checkOutInSettings.setPersonLoggedIn && !this.checkOutInSettings.setPersonLoggedInBoth) {
          this.setPersonFocus();
        }
      }, 100);
    }
  }
  // #endregion
  // #endregion

  setLocationFocus() {
    setTimeout(() => {
      this.kendoComboLocation?.toggle(true);
      this.kendoComboLocation?.focus();
    }, 2000);
  }

  setPersonFocus() {
    //setTimeout(() => {
    this.kendoComboPersons?.toggle(true);
    this.kendoComboPersons?.focus();
    //}, 2000);
  }

  setAssetFocus() {
    //setTimeout(() => {

    this.kendoComboAssets.toggle(true);
    this.kendoComboAssets.focus();
    //}, 2000);
  }



  // #region Persons Drop Down

  async getPersonsDD() {
    var response = this._usersService.getActivePersons();
    var data = await firstValueFrom(response);
    if (data) {
      this.personsData = data.body;
    }
    /* this._usersService.getActivePersons().subscribe((data: any) => {
      this.personsData = data;
    }); */
  }

  _openPersonsList(): void {
    if (this._personsGridFields == undefined || this._personsGridFields.length == 0) {
      this._getPersonsGridFields();
    }
    this._personsListEnabled = true;
  }

  _getPersonsGridFields() {
    this._gridFields.getGridFieldsByPage(this._personsPageName).subscribe((data: any) => {
      this._gridLayoutManagerService.setGridColumnSubjects(this._personsPageName, data);
    });
    this._gridLayoutManagerService.subscribeToColumnsChanges(this._personsPageName, (gridColumns) => {
      this._personsGridFields = gridColumns;
    });
  }

  _closePersonsList(): void {
    this._personsListEnabled = false;
  }

  _returnSelectedPersonsHandler(e: UserSummary): void {
    this._usersService.getPersonById(this._selectedPerson).subscribe((data: any) => {
      if (this.personsData.find(f => f.id == data.id) == undefined) {
        this.personsData.push(data);
      }
      this._personsDD.setValue(data);
      this._form.patchValue({
        checkOutToPerson: data
      });
    });

    this._closePersonsList();
  }

  _onPersonRowSelectionChanges(e: any[]) {
    this._selectedPerson = e[0];

  }

  _onPersonObjectRowSelectionChanges(e: any[]) {

  }

  _getPersons = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._usersService.getPersonsGridData(params, model);
  };

  async _onCloseAddPersons(data: any) {
    const tempData = this.personsData;
    await this.getPersonsDD();

    if (tempData.length != this.personsData.length) {
      let latestItem = this.personsData.at(this.personsData.length - 1);
      // let newItem = data.response;
      //   this.personsData.push(newItem);
      this._personsDD.setValue(latestItem);
      this._form.patchValue({
        checkOutToPerson: latestItem
      });

      this._form.controls.checkOutToPerson.updateValueAndValidity();
      this._personsDD.updateValueAndValidity();
    }
  }

  _handlePersonChange(e: any) {
  }

  getUserSites(sites: any[]) {
    var retVal: string = '';
    retVal = sites?.map(d => d.site?.code ?? 'All Sites').join(', ');
    return retVal;
  }
  GetPrimaryManagerData(Managers: any, field: string) {
    if (Managers && Managers.length > 0) {
      let PrimaryManager: any = Managers.find((x: any) => x.isPrimary == true);

      if (PrimaryManager && PrimaryManager.manager) {
        if (field == 'managers.manager.code') {
          return PrimaryManager.manager.code;
        }

        if (field == 'managers.manager.firstName') {
          return PrimaryManager.manager.firstName
        }

        if (field == 'managers.manager.lastName') {
          return PrimaryManager.manager.lastName;
        }
      }
    }

    return "";
  }
  // #endregion

  addSelectedItem(assets: IAssetDto[]): void {
    const assetIds = assets.map(a => a.id);

    this._assetReservationService.checkAssetForReservation(assetIds, this._form.controls.toBeCheckedOutDate.value, this._form.controls.toBeCheckedInDate.value, this._model.id ?? 0)
      .pipe(
        finalize(() => {
          //this._onClear();
        }
        ))
      .subscribe((response: any) => {

        let responseMsg = response.message;
        let ignoredIds = response.data;
        if (ignoredIds) {
          const ignoredIdList = ignoredIds
            .split(',')
            .map((id: string) => Number(id.trim()))
            .filter((id: number) => !isNaN(id));

          const ignoredAssets = (assets ?? []).filter(a => ignoredIdList.includes(a.id));
          if (ignoredAssets.length > 0) {
            const assetNumbers = ignoredAssets.map(a => a.assetNumber).join(', ');
            responseMsg = `This Asset, ${assetNumbers}, is already reserved during the selected period.`;
          }

          assets = (assets ?? []).filter(a => !ignoredIdList.includes(a.id));
        }

        if (responseMsg && responseMsg != "") {
          this._layoutComponent.openPopup({
            title: 'Alert',
            message: responseMsg,
            withoutConfirm: true
          });

        }

        assets.forEach((asset: IAssetDto) => {
          let checkAsset = this._selectedItems.find((x: any) => x.assetId === asset.id);

          if (checkAsset == undefined) {

            let assetData = this.buildSelectedItem(asset);
            this._selectedItems.push(assetData);
            this._form.controls.assetNumber.setValue(null);

          }
        });

      });



  }


  buildSelectedItem(asset: IAssetDto): IAssetReservationDetailsDto {
    const itemData: IAssetReservationDetailsDto = {
      id: 0,
      assetId: asset.id,
      index: this._selectedItems.length,
      assetNumber: asset.assetNumber,
      assetName: asset.assetName,
      locationCode: asset.location?.code,
      asset: asset,
      isCheckedOut: false,
    };

    return itemData;
  }

  _removeAllItems() {
    this._selectedItems = [];

  }

  _handleAssetListBlur() {
    this._assetComboScroll = false;
  }

  _handleAssetChange() {
    setTimeout(() => {
      if (this._checkAssetExistsInList()) {
        this._startAddAsset();

      }
    }, 250);
  }

  _handleAssetKeyEnter() {
    if (this._form.controls.assetNumber.value == null) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please select an asset to continue',
        withoutConfirm: true
      });

      this.setAssetFocus();

      return;
    }

    if (this._checkAssetExistsInList()) {
      // if (!this._form.controls.checkOutDueDays.value && this._form.controls.checkOutDueDays.value == false) {
      //   this.kendoComboAssets.blur();
      //   this.asset_DueDays.focus();
      // }
      // else {
      this._startAddAsset();
      // }
    }
  }

  _handleDueDaysKeyEnter() {
    this._startAddAsset();
  }

  _startAddAsset() {
    if (this._form.controls.assetNumber.value == null) {

      this.setAssetFocus();

      return;
    }

    let settingsHasTimeFrame: boolean = false;

    if (this.checkOutInSettings.defaultDateTimeFrame != undefined && this.checkOutInSettings.defaultDateTimeFrame != null) {
      settingsHasTimeFrame = true;
    }


    let _selectedAssetId = this._form.controls.assetNumber.value.id;
    this._assetService.getAssetById(_selectedAssetId).subscribe((data: IAssetDto) => {

      this.addSelectedItem([data]);
    });

  }

  _checkAssetExistsInList(): boolean {
    let _selectedAssetId = this._form.controls.assetNumber.value?.id;
    let _checkAsset = this._selectedItems.find(x => x.assetId === _selectedAssetId);

    if (_checkAsset == undefined) {
      return true;
    }
    else {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Asset is already added to the items',
        withoutConfirm: true
      });

      return false;
    }
  }

  _handleRemoveSelectedItem(item: IAssetDto) {
    let val1 = this._selectedItems.find(f => f.id === item.id);
    this._selectedItems.splice(this._selectedItems.indexOf(val1), 1);
    this._selectedItems = this._selectedItems.filter((x: any) => x.rowindex != this._selectedItems.indexOf(val1));

    let val = this.selectedItems.value.find((f: any) => f.id == item.id);
    this.selectedItems.value.splice(this.selectedItems.value.indexOf(val), 1);
    let ctrl = this.selectedItems.controls.find(g => g.value.id == item.id);
    this.selectedItems.controls.splice(this.selectedItems.controls.indexOf(ctrl), 1);
    this._selectedItems = [];
    this._selectedItems = this.selectedItems.value.map((f: { assetData: IAssetDto; }) => f.assetData);
    this._sharedService.onDeleteFromGrid.emit(true);
    /* remove from _gridSelectedAssets */
    let sVal = this._gridSelectedAssets.find(f => f === item.id);
    this._gridSelectedAssets.splice(this._gridSelectedAssets.indexOf(sVal), 1);
    if (this._selectedItems.length == 0) {
      this._gridSelectedAssets = [];
      this.SelectedItemsGrid.ClearSelectedKeys();
    }
  }

  setAssetListType() {
    this._checkOutInSettingsService.getCheckOutInSettings().subscribe((data: ICheckOutInSettings) => {
      this.checkOutInSettings = { ...data };

      if (this.checkOutInSettings.allowCheckOutOfCheckedAssets == true) {
        this._assetListType = AssetListMode.includeCheckedOut;

      }
    });
  }
  /* Selection and Batch Removal */
  _onDetailsRowSelectionChanges(e: any[]) {
    this._gridSelectedAssets = [...e];
  }

  _onRemoveDetailsBatch() {
    if (this._gridSelectedAssets && this._gridSelectedAssets.length > 0) {
      this._gridSelectedAssets.forEach((s: number) => {
        let val1 = this._selectedItems.find(f => f.id === s);
        this._selectedItems.splice(this._selectedItems.indexOf(val1), 1);
        this._selectedItems = this._selectedItems.filter((x: any) => x.rowindex != this._selectedItems.indexOf(val1));

        let val = this.selectedItems.value.find((f: any) => f.id == s);
        this.selectedItems.value.splice(this.selectedItems.value.indexOf(val), 1);
        let ctrl = this.selectedItems.controls.find(g => g.value.id == s);
        this.selectedItems.controls.splice(this.selectedItems.controls.indexOf(ctrl), 1);
        this._selectedItems = [];
        this._selectedItems = this.selectedItems.value.map((f: { assetData: IAssetDto; }) => f.assetData);
        this._sharedService.onDeleteFromGrid.emit(true);
      });

      this._gridSelectedAssets = [];
      this.SelectedItemsGrid.ClearSelectedKeys();
    }
  }

  //#region Assets Data Listing
  getAssetsDD() {
    if (!this._assetComboScroll) {
      this._assetService.getAssetDropDownListData(this._assetListType, this._assetComboBoxPagingParams)

        .subscribe((data: any) => {
          this._allAssetCount = data.body.returnCount;
          this.assetsData = [...data.body.data];
          this.assetsDataFiltered = [...data.body.data];
        });
    }
    else {
      this._assetService.getAssetDropDownListData(this._assetListType, this._assetComboBoxPagingParams)

        .subscribe((data: any) => {
          this._allAssetCount = data.body.returnCount;
          this.assetsData = this.assetsData.concat(data.body.data);
          this.assetsDataFiltered = [...this.assetsData];
        });
    }
  }

  _openAssetsList(): void {
    if (this._assetsGridFields == undefined || this._assetsGridFields.length == 0) {
      this._getAssetsGridFields();
    }
    this._assetsListEnabled = true;
  }

  _getAssetsGridFields() {
    this._gridFields.getGridFieldsByPage(this._assetsPageName).subscribe((data: any) => {
      this._gridLayoutManagerService.setGridColumnSubjects(this._assetsPageName, data);
    });

    this._gridLayoutManagerService.subscribeToColumnsChanges(this._assetsPageName, (gridColumns) => {
      this._assetsGridFields = gridColumns;
    });
  }

  _closeAssetsList(): void {
    this._assetsListEnabled = false;
  }

  _returnSelectedAssetsHandler(e: IAssetDto): void {
    this._assetService.getAssetRange(this._selectedAssets).subscribe((data: IAssetDto[]) => {
      //check black listed Conditions
      let _conditionMsg: string = '';
      let addedCount: number = 0;

      this.addSelectedItem(data);
      // data.forEach((item: IAssetDto) => {
      //   if (this._blackListedConditions.includes(item.conditionId)) {
      //     if (_conditionMsg == '') {
      //       _conditionMsg = 'Cannot add the following asset(s): <br>'
      //     }

      //     _conditionMsg = _conditionMsg + `Asset No. \"${item.assetNumber}\" cannot be added as its condition \"${item.condition.conditionId}\" is blacklisted. <br>`
      //   }
      //   else {
      //     if (this.assetsData.find(f => f.id == item.id) == undefined) {
      //       this.assetsData.push(item);
      //     }

      //     this._assetsDD.setValue(item);
      //     this._form.patchValue({ assetNumber: item });

      //     this.addSelectedItem(item);
      //     addedCount++;
      //   }
      // });

      if (_conditionMsg != '') {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: addedCount > 0 ? 'One or more asset(s) has blacklisted condition(s) and were not added.<br> Only asset(s) with allowed condition(s) were added.' :
            'All selected asset(s) have blacklisted condition(s) and cannot be added.',
          withoutConfirm: true
        });

        return;
      }
    });

    this._closeAssetsList();
  }

  _onAssetsRowSelectionChanges(e: any[]) {
    this._selectedAssets = [...e];
  }

  _onAssetsObjectRowSelectionChanges(e: any[]) {

  }

  _getAssets = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    let siteIdd: number | null;

    if (!this._currentUser.isEnterprise) {
      siteIdd = this._form.get('site').value?.id ?? this.siteId;
    }

    this.getCheckOutInSettings();

    return this._assetService.getAssetGridByMode(params, this._assetListType, model, siteIdd);
  };

  _onOpenAssetForm(): void {
    this._openForm(this._assetsPageName);
  }

  _onCloseAddAsset(data: any) {
    let newItem = data.response;
    this.assetsData.push(newItem);
    this._assetsDD.setValue(newItem);
    this._form.patchValue({ assetNumber: newItem });

    this.addSelectedItem(newItem);
  }

  _skipAddNewAsset() {
    this._form.controls.assetNumber.setValue(null);
    this._assetDDSearch = '';
    this.kendoComboAssets.blur();
    this.setAssetFocus();
  }

  _handleAssetsFilter(_filter: any) {
    this._assetDDSearch = _filter;
    this._assetComboScroll = false;
    this._assetComboBoxPagingParams.search = _filter;
    this._assetComboBoxPagingParams.currentItem = '0';
    this._assetComboBoxPagingParams.page = 1;
    this.getAssetsDD();
  }

  scrollCombobox(event: any) {
    this.isOpened = true;

    if (this.clearTimeout) {
      clearTimeout(this.clearTimeout);
    }

    this.clearTimeout = setTimeout(() => {
      if (this.isOpened) {
        let domobject = document.querySelector('.k-list-content');

        if (domobject) {
          this._renderer2.listen(document.querySelector('.k-list-content'), 'scroll', (e: any) => {
            if (this.assetsData.length < this._allAssetCount) {
              if (e.target.offsetHeight + e.target.scrollTop >= e.target.scrollHeight - 5) {
                this._assetComboScroll = true;
                this._assetComboBoxPagingParams.currentItem = (parseInt(this._assetComboBoxPagingParams.currentItem) + this._assetComboBoxPagingParams.totalbyPage).toString();
                this._assetComboBoxPagingParams.page++;
                this.getAssetsDD();
              }
            }
          });
        }
      }
    }, 500);
  }

  _handleAssetValueChange(selectedData: IAssetListing) {
    //this._pacer.start();
    this._form.patchValue({
      assetNotes: ''
    });

    this._notesService.getNotesByPage(selectedData?.id, 'assets').subscribe((data: NoteSummary[]) => {
      if (data != undefined) {
        if (data.length > 0) {
          data.reverse();
          this._form.patchValue({
            assetNotes: data[0].description
          });
        }
      }
    });
  }

  displayAssetImage(input: string, ListOfItems: any = null) {
    let primaryPicture;

    if (ListOfItems != null && ListOfItems.length > 0) {
      primaryPicture = ListOfItems.find((v: any) => v.assetFileisPrimary == true);
      if (primaryPicture == undefined && primaryPicture == null) {
        primaryPicture = ListOfItems[0];
      }

      input = primaryPicture.file.thumbnail;
      return EnvironmentLoaderService.envConfig.enterpriseApiLocal + '/' + input;
    }
    else return '';
  }

  displayModelImage(input: string, ListOfItems: any = null) {
    let primaryPicture;

    if (ListOfItems != null && ListOfItems.length > 0) {
      primaryPicture = ListOfItems.find((v: any) => v.modelFileisPrimary == true);
      if (primaryPicture == undefined && primaryPicture == null) {
        primaryPicture = ListOfItems[0];
      }

      input = primaryPicture.file.thumbnail;

      return EnvironmentLoaderService.envConfig.enterpriseApiLocal + '/' + input;
    }
    else {
      return '';
    }
  }
  //#endregion


  // #region Custom Fields / Forms Actions
  formStatus(isInvalid: boolean) {
    this._custominvalidForm = isInvalid;
  }
  _onEditFields() {
    if (!this._currentUser.isEnterprise) {
      this._pageState = PageState.EDIT_FIELDS;
    } else {
      this._editFormActive = true;
      this._isCustomfieldsFormValue = true;
    }
  }
  _addNewTab() {
    this._editFormActive = true;
    this._isAddTabFormValue = true;
    this._isRenameLabel = false;
    this._selectedLabelId = null;
  }
  _addNewField(tabId: number) {
    this._selectedTabId = null;
    this._selectedTabId = tabId;
    this._editFormActive = true;
    this._isCustomfieldsFormValue = true;
    this._isRenameLabel = false;
    this._selectedLabelId = null;
  }
  _openRenameForm(objectCode: string, isMandatory: boolean = false) {
    this._selectedLabelObjectCode = objectCode; //todo send system field label id
    //return; //open form once label id is set
    this._editFormActive = true;
    this._isRenameFormValue = true;
    this._isRenameCustomFormValue = false;
    this._isRenameLabel = true;
    this._isMandatory = isMandatory;
  }
  _openCustomRenameForm(customFieldId: number, tabId: number) {
    this._selectedLabelId = customFieldId;
    this._selectedTabId = tabId;
    this._editFormActive = !isNaN(customFieldId);
    this._isRenameFormValue = !isNaN(customFieldId);
    this._isRenameCustomFormValue = !isNaN(customFieldId);
    this._isRenameLabel = false;
    this._isMandatory = false;
  }

  _reactivateField(item: any) {
    this.reactivateItem = item;
    this.reactivate = true;
    this._sharedService.okCloseClicked.subscribe((data: boolean) => {
      if (data && this.reactivate) {
        this.reactivate = false;
        this._customFieldsService.reactivateCustomField(this.reactivateItem.id, item)

          .subscribe((response: any) => {
            this.getSystemFieldsAndCustomFields();
            this._deactivatedFieldsForm = false;
            //get tabid,if not in list call get systemtabs
            var deletedTab = this._dataTabs.find(f => f.id == item.formTabId && f.isCustom == true);
            if (deletedTab == undefined) {
              this.getFormTabs();
            }
            if (response != null && response['message'] != null) {
              this._layoutComponent.openPopup({
                title: 'Alert',
                message: response['message'],
                withoutConfirm: true
              });
              /* if (response['close'] != null) {
                if (response['close'] == true) {
                  //this.loadCustomFields(this._model?.id?.toString());
                } else {
                  return;
                }
              } */
            }
            this._deactivatedFieldsForm = false;
          });
        this._deactivatedFieldsForm = false;
      } else {
        this.reactivate = false;
      }
    });

    this._layoutComponent.openPopup({
      title: 'Notification',
      message: 'Are you sure you want to Reactivate ' + item.name
    });
    //this.loadCustomFields(this._model?.id?.toString());
    /* this.getSystemFieldsAndCustomFields();
    this._customFieldsService
    .getDeactivatedCustomFields(this._entity,this._page)
    
    .subscribe((data: Array<any>) => {
      this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page)
    }); */
  }
  _closeInactiveFields() {
    this._deactivatedFieldsForm = false;
  }
  dataMove(newLocData: any, oldLocData: any, dataTab?: FormTabSummary) {
    const sysF: GridFieldSummary[] = this._systemFields.filter(f => f.formTabId == dataTab.id);
    const sysFClone: any[] = [];

    sysF.forEach((element: any) => {
      sysFClone.push(Object.assign({}, element));
    });
    sysF.find((x: { id: any; }) => x.id === oldLocData.id).formOrder =
      sysFClone.find((x) => x.id === newLocData.id).formOrder;
    sysF.find((x: { id: any; }) => x.id === newLocData.id).formOrder =
      sysFClone.find((x) => x.id === oldLocData.id).formOrder;

    this._editedSystemFields = sysF;
  }
  dragEnd() {
    this._gridFields.updatedSystemFieldReorder(this._editedSystemFields).subscribe((x: GridFieldSummary[]) => {
      this._systemFields = x;
      this._editedSystemFields = x;
    });
  }
  _customFieldsValueChanges(customFieldsValue: any, tabId: number) {
    if (this._customFieldsValue == undefined) { this._customFieldsValue = []; }
    Object.keys(customFieldsValue).forEach((key) => {
      let customObject = {
        Key: key,
        Value: customFieldsValue[key],
      };
      let item = null;
      this._customFieldsValue.forEach((elementz: any) => {
        if (elementz.Key == key) {
          item = elementz;
        }
      });
      if (item != null) {
        let index = this._customFieldsValue.indexOf(item);
        if (index != -1) {
          this._customFieldsValue.splice(index, 1);
        }
      }
      var requiredCustomerField = this._customValidation.find(
        (x: any) => x.name == key
      );
      if (requiredCustomerField) {
        let item2 = null;
        this._customValidation.forEach((element: any) => {
          if (element.name == key) {
            item2 = element;
          }
        });
        if (item2 != null) {
          let index2 = this._customValidation.indexOf(item2);
          if (index2 != -1) {
            //this._customValidation.splice(index2, 1);
            this._customValidation[index2].value = customObject.Value;
          }
          //this._customValidation.push({'name': customObject.Key, 'value': customObject.Value})
        }
      }
      this._additionalErrors = [];
      if (this._customValidation.find((x: any) => !x.value)) {
        this._additionalErrors.push("Additional Error");
        this._additionalErrors = [];
      }
      this._customFieldsValue.push(customObject);
    });

  }
  _removeCustomField(customFieldId: number) {
    for (var i = 1; i <= this._customFields.length; i++) {
      if (this._customFields[i] != null) {
        if (
          this._customFields[i].findIndex((x) => x.id == customFieldId) != -1
        ) {
          this._customFields[i] = this._customFields[i].filter(
            (x) => x.id != customFieldId
          );
          return;
        }
      }
    }
  }
  ClosePopup(event: boolean) {
    if (event == true) {
      this._closeCustomFields();
    }
  }
  _closeCustomFields() {
    this._editFormActive = false;
    this._isCustomfieldsFormValue = false;
    this._isAddTabFormValue = false;
    this._isRenameFormValue = false;
    //this.loadCustomFields(this._model?.id?.toString());
    this.getSystemFieldsAndCustomFields();
    this.loadLabels();
    this.getFormTabs();
    this.getAuth();
  }
  _getInactiveFields() {
    this._customFieldsService
      .getDeactivatedCustomFields(this._entity, this._page)

      .subscribe((data: Array<any>) => {
        this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page)
      });
  }
  // #endregion
  //#region Transactions Field Editor
  onShowTransactionFieldEditor(objectCode: string) {
    this._showTransactionFieldEditor = true;
    this._transactionsFieldEditorObjectCode = objectCode;
  }
  onCloseTransactionFieldEditor() {
    this._showTransactionFieldEditor = false;
  }
  //#endregion


  //#region Attach Document
  _getAccountDocuments = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    return this._filesService.getAllDocuments(this._selectedAccountIds, params, model);
  }

  _fileSelectedChanges(ev: SelectEvent) {
    ev.files.forEach((file: FileInfo) => {
      if (file.rawFile) {
        this._file = file.rawFile;
        if (this.checkFileExtention()) {
          const reader = new FileReader();
          reader.readAsDataURL(file.rawFile);

          reader.onloadend = () => {
            this._fileStream = reader.result;
            let _selectedFileModel: FileSelectedStream = <FileSelectedStream>({
              stream: reader.result,
              size: file.rawFile.size,
              type: file.rawFile.type,
              name: file.rawFile.name,
              fileSource: fileSources.assetCheckOutTransaction,
              isNew: true
            });

            this._uploadedStream.push(_selectedFileModel);
          };
        }
      }
    });

    this._selectFile = this._fileSelectedChanges.length > 0;
  }

  private checkFileExtention(): boolean {
    let fileUploadedName = this._file.name;
    const allowedExtensions = ['doc', 'docx', 'csv', 'xls', 'xlsx', 'pdf'];
    const reg = /(?:\.([^.]+))?$/;
    const fileType = reg.exec(fileUploadedName)[1];

    if (allowedExtensions.indexOf(fileType) == -1) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Only DOC, DOCX, XLS, XLSX, PDF and CSV extensions are allowed.',
        withoutConfirm: true
      });

      setTimeout(() => {
        this.upload.clearFiles();
        this._file = null;
        this._fileStream = null;
      });

      return false;
    }
    else {
      return true;
    }
  }

  _fileRemoveEventHandler(e: any) {
    let fileName = e.files[0].name;
    let delFile: FileSelectedStream = this._uploadedStream.find(f => f.name.toLowerCase() == fileName.toLowerCase());
    if (delFile != undefined) {
      let indx = this._uploadedStream.indexOf(delFile);
      this._uploadedStream.splice(indx, 1);
    }
    this._fileStream = null;
  }

  _onUploadClick() {
    let kendoUploader = this.uploadWrapper.nativeElement.querySelector('input');
    kendoUploader.click();
  }

  async _saveTransactionFiles() {
    let newFiles = [...this._uploadedStream];
    let existingFiles = [...this._selectedExistingFiles];

    if ((newFiles != undefined && newFiles.length > 0) || (existingFiles != undefined && existingFiles.length > 0)) {
      let _filesModel: any[] = [];
      newFiles.forEach(n => {
        let model: any = {};
        model.stream = n.stream;
        model.size = n.size;
        model.type = n.type;
        model.name = n.name ? n.name.substring(0, n.name.lastIndexOf('.')) : '';
        model.exension = n.name.substring(n.name.lastIndexOf(".") + 1).toLowerCase();
        model.typesToChecks = this._allowedFileTypes;
        model.existingFileId = n.existingFileId;
        model.fileSourceId = fileSources.assetReservation;
        _filesModel.push(model);
      });

      await this._filesService.createFileRange(_filesModel).subscribe((response: number[]) => {
        if (response != null) {
          existingFiles.forEach((v) => {
            let ext = response.find(r => r == v.existingFileId);
            if (ext == undefined) {
              response.push(v.existingFileId);
            }
          });

          this._addReservation(response)
        }
      });
    }
  }

  _closeDocumentsWindow(): void {
    this._showDocumentsGrid = false;
  }

  _returnSelectedDocumentsHandler(e: any): void {
    this._selectedExistingFiles = [];
    this._selectedDocumentsKeys = [];
    if (this._currentUser.isEnterprise) {
      if (this._selectedAccountIds.length) {
        this._showDocumentsGrid = false;
        let currentSelected = this._selectedDocumentsKeys.concat(this._selectedDocuments);
        this._selectedDocumentsKeys = currentSelected.filter((c, index) => {
          return currentSelected.indexOf(c) === index;
        });
      }
      else {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Please choose the account with the site desired',
          withoutConfirm: true
        });
      }
    }
    else if (!this._currentUser.isEnterprise) {
      this._showDocumentsGrid = false;
      let currentSelected = this._selectedDocumentsKeys.concat(this._selectedDocuments);
      this._selectedDocumentsKeys = currentSelected.filter((c, index) => {
        return currentSelected.indexOf(c) === index;
      });
      this._selectedDocumentsKeys.forEach((v) => {
        let _selectedFileModel: FileSelectedStream = <FileSelectedStream>({
          stream: '',
          size: 0,
          type: '',
          name: '',
          fileSource: fileSources.assetCheckOutTransaction,
          isNew: false,
          existingFileId: v
        });
        this._selectedExistingFiles.push(_selectedFileModel);
        this._uploaderSelectMessage = 'Upload file..' + ` [ ${this._selectedExistingFiles.length} file(s) selected ]`;
      });
    }
  }

  _onDocumentRowSelectionChanges(e: any[]) {
    this._selectedDocuments = [];
    e.forEach((item) => {
      this._selectedDocuments.push(+item);
    });
  }

  _onRowObjectSelectionindexList(e: any[]) {
    if (e.length > 0) {
      let selectedrowsindex = e.map((a) => a.index);
      if (this._selectedInventoryKeys != undefined && this._selectedInventoryKeys != null && this._selectedInventoryKeys.length > 0) {
        selectedrowsindex.forEach((x: any) => {
          let isexist = this._selectedInventoryKeys.find((d: any) => d == x);
          if (isexist == undefined) {
            this._selectedInventoryKeys.push(x);
          }
        })
      }
      else
        this._selectedInventoryKeys = selectedrowsindex;
    }
  }

  _onDocumentbjectRowSelectionChanges(e: any[]) {
    this._selectedObjectDocuments = [];
    this._selectedObjectDocuments = e;
  }
  //#endregion

  // #region Page Specific
  _closeDialog(fileData: any) {
    this._isDialiog = false;
  }

  ExpandCollapseGeneralInfoWidget(isExpand: boolean) {
    this.isGeneralInformationExpanded = !isExpand;
  }

  ExpandCollapseScanAssetWidget(isExpand: boolean) {
    this.isScanAssetExpanded = !isExpand;
  }


  _openForm(componentName: string, objectname: any = null) {
    this._isDialiog = true;
    this._dialogComponentName = componentName;
    this._dialogModel = { model: {}, pageState: PageState.ADD, reload: 'model', fileSource: fileSources.assetCheckOutTransaction, accessFrom: 'assets', transactionAssetNumber: this._assetDDSearch };
    this._isMandatory = false;
    this.selectedobjectname = objectname;
  }


  //#region  Print Receipt Functions
  _printReceiptReport() {
    var reportId = this.selectReceiptReport.value.id;
    this._layoutComponent.openDialogForm(ReportViewerPopupComponent, PageState.VIEW, { reportId: reportId, transactionId: this.transactionId });
    this._onClear();
  }

  _onClear() {
    this._selectedDocumentsKeys = [];
    this._uploadedStream = [];
    this._selectedExistingFiles = [];
    this._uploaderSelectMessage = 'Upload file..';
    this.transactionId = null;
    this._invalidForm = false;
    this._form.reset();
    this.selectedItems.clear();
    this._selectedItems = [];
    this.setAssetListType();
    this._form.patchValue({
      reservationMadeDate: new Date(),
    });
  }
  _closePrintReceiptWindow() {
    this.showReports = false;
  }
  //#endregion

  _removeHandler({ sender, dataItem }: any) {
    this._selectedItems = this._selectedItems.filter((x: any) => x.assetId != dataItem.assetId);

  }


  //#region Save Actions
  async _onSave(event: string) {

    if (this.checkOutInSettings.chechOutToPerson == true) {
      this._form.controls.checkOutToLocation.removeValidators(Validators.required);
    }
    if (this.checkOutInSettings.chechOutToLocation == true) {
      this._form.controls.checkOutToPerson.removeValidators(Validators.required);
    }


    if (!this._form.controls['reservationMadeDate'].value) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please Add Reservation Date.',
        withoutConfirm: true
      });
      return false;
    }


    if (!this._form.controls['reservationNumber'].value) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please Add Reservation Number.',
        withoutConfirm: true
      });
      return false;
    }


    if (!this._form.controls['toBeCheckedOutDate'].value) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please Add CheckedOut Date.',
        withoutConfirm: true
      });
      return false;
    }

    if (!this._form.controls['toBeCheckedInDate'].value) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please Add CheckedIn Date.',
        withoutConfirm: true
      });
      return false;
    }

    if (!this._form.controls.checkOutToPerson.value && (this.checkOutInSettings.chechOutToPerson || this.checkOutInSettings.chechOutToBoth)) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please select a Person.',
        withoutConfirm: true
      });
      return false;
    }

    if (!this._form.controls.checkOutToLocation.value && (this.checkOutInSettings.chechOutToLocation || this.checkOutInSettings.chechOutToBoth)) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please select a Location.',
        withoutConfirm: true
      });
      return false;
    }

    if (this._selectedItems === undefined || this._selectedItems.length == 0) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'No assets available for Reservation.',
        returnAfterOkCloseClick: true,
        withoutConfirm: true,
      });
    }
    else {

      let assets = this._selectedItems;
      const assetIds = assets.map(a => a.assetId);
      var responseMsg = "";
      this._assetReservationService.checkAssetForReservation(assetIds, this._form.controls.toBeCheckedOutDate.value, this._form.controls.toBeCheckedInDate.value, this._model.id ?? 0)
        .pipe(
          finalize(() => {
            //this._onClear();
          }
          ))
        .subscribe((response: any) => {
          responseMsg = response.message;

          let ignoredIds = response.data;
          if (ignoredIds) {
            const ignoredIdList = ignoredIds
              .split(',')
              .map((id: string) => Number(id.trim()))
              .filter((id: number) => !isNaN(id));

            const ignoredAssets = (assets ?? []).filter((a: any) => ignoredIdList.includes(a.assetId));
            if (ignoredAssets.length > 0) {
              const assetNumbers = ignoredAssets.map((a: any) => a.assetNumber).join(', ');
              responseMsg = `This Asset, ${assetNumbers}, is already reserved during the selected period.`;
            }
          }

          if (responseMsg && responseMsg != "") {
            this._layoutComponent.openPopup({
              title: 'Alert',
              message: responseMsg,
              withoutConfirm: true
            });

          }
          else {
            this._processTransaction(event)

          }


        });

    }
  }

  async _processTransaction(event: string) {
    if (this._form.invalid) {
      this._invalidForm = true;
    }
    else {
      this._invalidForm = false;
    }

    if (this._invalidForm == false) {
      if (this._uploadedStream.length > 0 || this._selectedExistingFiles.length > 0) {
        await this._saveTransactionFiles();
      }
      else {
        this._addReservation(null, event);
      }
    }
  }

  _addReservation(fileIds?: number[], event?: string) {
    var saveModel: IAssetReservationDto = this.generateRequestModel();

    if (fileIds) {
      saveModel.assetReservationFiles = fileIds.map((v: number) => {
        return {
          fileid: v,
          assetReservationId: 0,
          file: null as any,
          id: 0,
          status: EntityStatusOptions.Active
        }
      });
    }
    else {
      saveModel.assetReservationFiles = [];
    }

    this.doCreateReservation(saveModel, event);

  }

  generateRequestModel(): IAssetReservationDto {


    const requestModel: IAssetReservationDto = <IAssetReservationDto>({
      id: this._model?.id ?? 0,
      siteId: this.siteId,
      reservationNumber: this._form.controls.reservationNumber.value,
      toBeCheckedOutDate: this._form.controls.toBeCheckedOutDate.value,
      toBeCheckedInDate: this._form.controls.toBeCheckedInDate.value,
      checkOutToPersonId: this._form.controls.checkOutToPerson.value?.id,
      checkOutToLocationId: this._form.controls.checkOutToLocation.value?.id,
      notes: this._form.controls.notes.value,
      assetReservationDetails: this._selectedItems,
      assetReservationFiles: [],
      reservationMadeDate: this._form.controls.reservationMadeDate.value,

    });

    return requestModel;
  }


  private doCreateReservation(saveModel: IAssetReservationDto, event?: string) {
    let modelData;
    if (this._pageState == this.pageState.ADD) {
      this._assetReservationService.createReservation(saveModel)
        .pipe(
          finalize(() => {
            //this._onClear();
          }
          ))
        .subscribe((response: any) => {
          //if(response.statusCode == 200){

          var msg = '';
          let newTransId = response.data?.dataId;
          this.transactionId = response.data.responseId;

          if (newTransId) {
            msg = 'Reservation # ' + newTransId + ' has been added successfully.';

          }
          else {
            msg = response.data?.message ?? response.message;
          }
          this._layoutComponent.openPopup({
            title: 'Alert',
            message: msg,
            withoutConfirm: true
          });

          modelData = response;
          this.buttonEvent(event, response);

        });
    }
    if (this._pageState == this.pageState.EDIT) {

      this._assetReservationService.updateReservation(this._model.id, saveModel)
        .pipe(
          finalize(() => {
            //this._onClear();
          }
          ))
        .subscribe((response: any) => {
          //if(response.statusCode == 200){
          var msg = '';
          let newTransId = response.data?.dataId;
          this.transactionId = response.data.responseId;
          if (newTransId) {
            msg = 'Reservation # ' + newTransId + ' has been updated successfully.';

          }
          else {
            msg = response.data?.message ?? response.message;
          }
          this._layoutComponent.openPopup({
            title: 'Alert',
            message: msg,
            withoutConfirm: true
          });
          modelData = response;
          this.buttonEvent(event, response);
        });
    }



  }

  buttonEvent(event: string, modelData: any) {
    if (event === 'saveAndClose') {
      this._closeForm();
    }
    else if (event === 'saveAndCopy') {
      this._form.controls.reservationNumber.setValue(null);
      this._pageState = PageState.ADD;
    }
    else if (event === 'saveAndNew') {
      this.openUpsert(this._page, {}, PageState.ADD);
    }
    // else if (event === 'saveAndPrint') {
    //   this._model = response;
    //   this._showPrintWindow();
    // }
    else if (event === 'save') {
      this._model = modelData.data.extraData;
      //this.getdata(true);
      //this.openUpsert(this._page, modelData, PageState.EDIT);
      this._pageState = PageState.EDIT;
      return this._assetReservationService.getReservationById(modelData.data?.responseId)

        .subscribe((model: any) => {
          this.openUpsert(this._page, model, PageState.EDIT);
        });
    }
  }
  getdata(afterSave: boolean = false) {
    if (!afterSave) {
      this._pageState = this._sharedService.model && this._sharedService.model.pageState ? this._sharedService.model.pageState : this.pageState.ADD;
      this._model = this._sharedService.model && this._sharedService.model.model ? this._sharedService.model.model : null;
    }
  }

  //#endregion


  getDateEnabledOption() {
    this._dateEditingSettings.getTransactionDateEditingSettings().subscribe((x: any) => {
      if (x != undefined && x != null) {
        this._dateEnabled = x.enabled;
        if (!this._dateEnabled) {
          this._form.get('reservationMadeDate')?.disable();
        }
      }
    });
  }

  _onEditForms() {
    this._isEditForms = true;
  }
  _onCloseEditForms(event: boolean) {
    this._isEditForms = event;
  }
  _returnAdNew() {
    this._pageState = PageState.ADD;
  }
  _viewInactiveFields() {
    this._getInactiveFields();
    /* this._customFieldsService
      .getDeactivatedCustomFields(this._entity, this._page)
      
      .subscribe((data: Array<any>) => {
        this._deactivatedFieldsGridData = data.filter(x => x.formTab.page === this._page);
      }); */
    this._deactivatedFieldsForm = true;
  }


  // #region Fields Tab Containers
  getCustomForm(event: any) {
    this._customForm = event;
  }

  _onTabSelect(e: SelectEvent): void {
    this._mobileMenuToggle();
  }

  _mobileMenuToggle() {
    let mobiletabstrip = this.screenTabs.nativeElement.querySelector('ul');
    if (mobiletabstrip.classList != undefined) {
      mobiletabstrip.classList.toggle('visibletab');
    }
  }

  getFormTabs() {
    try {
      this._gridFields.getformTabsByPage(this._page).subscribe((x: FormTabSummary[]) => {
        this._dataTabs = x;
        this._dataTabsSelected = x;
        this._userNewDataTabs = x;
        //this.sortProduct(p => p.order, "ASC");
      });
    } catch { }
  }

  getSystemFieldsAndCustomFields() {
    this._gridFields.getSystemFieldsByPage(this._page).subscribe((x: GridFieldSummary[]) => {
      this._systemFields = [...x];
      this._editedSystemFields = [...x];
      /* this._systemFields.forEach((s:GridFieldSummary, indx: number) =>{
        this._tabDisabledIndexes.push(indx);
      }) */
      this.loadCustomFields(this._model?.id?.toString());
    })
  }

  private loadCustomFields(entityId?: string) {
    //this._pacer.start();
    this._customFieldsService.getCustomFields(this._entity, this._page).subscribe((data) => {
      data = data.filter(x => x.formTab?.page == this._page);
      if (this._model != null && (this._model.id != null || this.copyModelId != null)) {
        let that = this;
        data.map(function (x) {
          x.entityId = that._model.id ?? that.copyModelId;
        });
      }
      var tabIds = data.map((item) => item.formTabId).filter((value, index, self) => self.indexOf(value) === index);

      const grouped = this.groupBy(data, (item: { formTabId: any }) => item.formTabId);
      let that = this;
      tabIds.forEach(function (formTabId) {
        that._customFields[formTabId] = grouped.get(formTabId);
      });

      if (this.copyModelId) {
        let CustomFieldsDataForCopy: any = {};
        grouped.forEach(element => {
          element.forEach((value: any) => {

            let _cutomfieldData = value.customFieldsData?.find((f: any) => f.entityId == entityId);
            CustomFieldsDataForCopy[value.name] = _cutomfieldData?.value ?? null;

            if (value.customFieldType.type.toLowerCase() == 'date' && CustomFieldsDataForCopy[value.name]) {
              CustomFieldsDataForCopy[value.name] = new Date(CustomFieldsDataForCopy[value.name]);
            }

            if (value.customFieldType.type.toLowerCase() == 'numeric' && CustomFieldsDataForCopy[value.name]) {
              CustomFieldsDataForCopy[value.name] = parseFloat(CustomFieldsDataForCopy[value.name]);
            }
          });

          this._customFieldsValueChanges(CustomFieldsDataForCopy, null);
        });
      }

      this.setMandatoryFields();
    });
    //this._pacer.start()
    this._customFieldsService.getFormTabsByPage(this._page).subscribe((data: any) => {
      //get custom tabs first
      this._customTabs = data.filter(
        (x: { isCustom: boolean }) => x.isCustom == true
      );
    });
  }

  groupBy(list: any[], keyGetter: any) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);

      if (!collection) {
        map.set(key, [item]);
      }
      else {
        collection.push(item);
      }
    });

    return map;
  }

  setMandatoryFields() {
    this._requiredFieldNames = [];
    this._requiredFields = [];
    this.requiredSystemTabs = [];
    this._customValidation = [];

    setTimeout(() => {
      for (let item of this._systemFields) {
        if (item.gridFieldText.isRequired) {
          this._requiredFields.push(item);
        }
      }

      for (let item2 of this._customFields) {
        if (item2) {
          for (let item3 of item2) {
            if (item3.isRequired) {
              this._requiredFields.push(item3);
            }
          }
        }
      }

      this._requiredFields.forEach((element: { isCustomField: any; formTab: any; formTabId: any; }) => {
        if (!element.isCustomField && element.isCustomField == null) {
          var tabName = element.formTab;
          this._requiredFieldNames.push(tabName);
        }
        else {
          if (element.formTabId) {
            let SystemFieldTab = this._dataTabs.find(x => x.id == element.formTabId);

            if (SystemFieldTab)
              this.requiredSystemTabs.push(SystemFieldTab);
          }
        }
      });

      if (this.screenTabs) {
        let tabElementList = this.screenTabs.nativeElement.querySelector('ul');

        Array.from(tabElementList.children).forEach((child: any) => {
          child.classList.remove('mendatoryTab');
        });

        Array.from(tabElementList.children).forEach((child: any) => {
          if (this._requiredFieldNames.find((x: { name: any; page: string; formtab: { page: string; }; }) => x.name === child.firstChild.innerText && (x.page ? x.page == this._page : x.formtab.page == this._page))) {
            child.classList.add("mendatoryTab")
          }

          if (this.requiredSystemTabs.find((x: any) => x.name === child.firstChild.innerText)) {
            child.classList.add('mendatoryTab');
          }
        });
      }

      this._requiredFields.forEach((element: { isCustomField: any; formTab: { name: any; }; customFieldsData: any[]; name: any; }) => {
        if (!element.isCustomField && element.isCustomField == null) {
          var tabName = element.formTab;
          this._requiredFieldNames.push(tabName);
        }

        if (element.customFieldsData != undefined) {
          let thisvalue = element.customFieldsData.filter((x: any) => x.entityId == (this._model.id > 0 ? this._model.id : this.copyModelId)).length > 0
            ? element.customFieldsData.filter((x: any) => x.entityId == (this._model.id > 0 ? this._model.id : this.copyModelId))[0].value
            : '';

          this._customValidation.push({
            name: element.name,
            value: thisvalue,
            tabName: element.formTab?.name,
          });
        }
      });
    }, 500);
  }

  _deactivateTab(tabId: number, page: string) {
    let model: any = {
      customFieldEntityId: page == this._page ? 1 : 2,
      page: this._page,
      accountIds: this._selectedAccountIds,
    };
    this._customFieldsService.deleteCustomTab(tabId, model).subscribe((response: any) => {
      if (response != null && response['message'] != null) {
        var deletedTab = this._dataTabs.find(f => f.id == tabId && f.isCustom == true);
        this._dataTabs.splice(this._dataTabs.indexOf(deletedTab), 1);
        //go to zero based tab
        this.screenTabStrip.selectTab(0);
        this._customFieldsService
          .getFormTabsByPage(this._page)

          .subscribe((data: any) => {
            //get custom tabs first
            this._customTabs = data.filter((x: { isCustom: boolean; }) => x.isCustom == true);
          });
        this._layoutComponent.openPopup({
          title: 'Alert',
          message: response['message'],
          withoutConfirm: true
        });
        if (response['close'] != null) {
          if (response['close'] == true) {

          } else {
            return;
          }
        }
      }

    });

  }
  _reorderingtabs() {
    this._orderingTabsForm = true;
  }
  _closeOrderingTabsForm() {
    this._orderingTabsForm = false;
    this._dataTabsSelected = this._userNewDataTabs;
  }
  _comboValueChange(e: any, i: number) {
    if (this._dataTabsSelected.find((x) => x.order == i + 1)) {
      this._userNewDataTabs.find(
        (x) => x === this._dataTabsSelected.find((x) => x.order == i + 1)
      ).order = this._dataTabsSelected.find((x) => x.name === e.name).order;
    }
    this._userNewDataTabs.find((obj) => obj.name == e.name).order = i + 1;
    //this._dataTabsSelected = this._dataTabsSelected.filter((obj) => obj !== e);
  }
  _onSaveTabOrdering() {
    this._gridFields
      .updateFormTabsReorder(this._userNewDataTabs)

      .subscribe((x: any) => {
        this._dataTabs = x;
        this._closeOrderingTabsForm();
      });
  }
  // #endregion
}
